<template>
    <div>
        <i-form :model="dados_email" label-position="top" :rules="rules_validate" ref="form-mail">
            <form-item prop="assunto">
                <i-input v-model="dados_email.assunto" placeholder="Título" size="large" :disabled="disabled"></i-input>
            </form-item>
            <form-item prop="mensagem">
                <vue-editor v-model="dados_email.mensagem" :editorToolbar="custom_toolbar" :disabled="disabled"></vue-editor>
            </form-item>
        </i-form>
        <div class="floating-btn">
            <i-button type="primary" shape="circle" icon="md-send" @click="enviar"
                      :style="{padding: '6px 6px 6px 10px',fontSize: '32px'}"></i-button>
        </div>
    </div>
</template>

<script>
    import {editorToolbar} from "../../../helpers/utils.js";

    export default {
        name: "form-email",
        components: {
            VueEditor: () =>
                import("vue2-editor").then(({VueEditor}) => VueEditor)
        },
        props: {
            emails: Array,
            assunto: String,
            mensagem: String,
            url: String,
            onSend: Function,
            disabled: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                dados_email: {
                    assunto: "",
                    mensagem: "",
                    emails: []
                },
                rules_validate: {
                    assunto: [
                        {
                            required: true,
                            message: "Forneça o título para o e-mail",
                            trigger: "blur"
                        }
                    ],
                    mensagem: [
                        {
                            required: true,
                            message: "Descreva a solução aplicada do ticket",
                            trigger: "blur"
                        }
                    ],
                },
                custom_toolbar: editorToolbar,
            };
        },
        created() {
            this.dados_email.assunto = this.assunto;
            this.dados_email.mensagem = this.mensagem;
            this.dados_email.emails = this.emails;
        },
        methods: {
            enviar() {
                this.$refs['form-mail'].validate(async valid => {
                    if (!valid) {
                        this.$Message.error("Há campos não informados!");
                    } else {
                        this.$Spin.show();
                        try {
                            const {data} = await this.$axios.post(this.url, this.dados_email);
                            if (data.codigo == 0) {
                                this.$Message.error(`Erro!`);
                                this.onSend(0);
                            } else {
                                this.onSend(1);
                                this.$Message.success(`Email enviado`);
                            }
                            this.$Spin.hide();
                        } catch (error) {
                            console.warn(error);
                            this.$Message.error(`Erro! ${error}`);
                            this.onSend(0);
                            this.$Spin.hide();
                        }
                    }
                });
            }
        }
    };
</script>
